import { CreateMenuItemData, MenuItem, MenuService } from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useCreateNavigationItem(
  mutationOptions?: UseMutationOptions<MenuItem, HttpError, CreateMenuItemData>,
) {
  return useMutation({
    mutationFn: MenuService.createMenuItem,
    ...mutationOptions,
  });
}

export { useCreateNavigationItem };
